import SubSkill from './model';

export default SubSkill;



// WEBPACK FOOTER //
// ./data/ProgressTests/Skills/SubSkills/index.js